import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  getTotem,
  setAuthToken,
} from '../../api/apiFactory';
import {
  fetchBairros, fetchSecretarias, postZeladoria,
  fetchOrientacoes, fetchVerificarStatusCidade, fetchCarregarSolicitante, fetchConfiguracoes, fetchCategoriasPermitidas, fetchSecretarias3,
} from '../../api/endpoints';
import {
  abrirModalAssunto, abrirModalBairro, abrirModalCategoria, abrirModalProtocoloZeladoria, abrirModalUnidade,
} from '../../app/slices/modalSlice';
import { fetchGeocodeByCoords, fetchCoordsByAddress } from '../../api/googleMaps';
import { desfazerCidade, selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import { desfazerSecretaria, selectSecretaria } from '../../app/slices/secretariasSlice';
import {
  Alerta,
  Container, Divisor, Interno, AppBodyForm, BreadCumbs, FormFooterTotem,
} from '../../styles/base';
import {
  cep, number, sus,
} from '../../util/mascaras';
import Botao from '../Botao/Botao';
import Carregar from '../Carregar/Carregar';
import FormControl from '../FormControl/FormControl';
import { LinhaForm } from '../FormControl/FormControlEstilo';
import Mapa from '../Mapa/Mapa';
import { Orientacoes } from './FormularioZeladoriaEstilo';
import { selectBairroTotem, desfazerBairro, selecionarBairro } from '../../app/slices/bairroTotemSlice';
import { desfazerAssunto, selectAssuntoTotem } from '../../app/slices/assuntoTotemSlice';
import { desfazerCategoria, selectCategoriaTotem } from '../../app/slices/categoriaTotemSlice';
import { desfazerUnidade, selectUnidadeTotem } from '../../app/slices/unidadeTotemSlice';
import { espacamento } from '../../styles/constants/sizes';

const defaultValues = {
  CartaoSus: '',
  Cep: '',
  DadosSigilosos: 'N',
  Descricao: '',
  Endereco: '',
  Foto: '',
  FuncionarioPublico: 'N',
  IdBairro: '',
  IdCategoria: '',
  IdSecretariaAssunto: '',
  Latitude: '',
  Longitude: '',
  Numero: '',
  Referencia: '',
  Urgente: 'N',
};

const FormularioZeladoriaTotem = () => {
  const [listaSecretarias, setListaSecretarias] = useState(null);
  const [listaCategorias, setListaCategorias] = useState(null);
  const [listaAssuntos, setListaAssuntos] = useState(null);
  const [listaUnidades, setListaUnidades] = useState(null);
  const [listaBairros, setListaBairros] = useState(null);
  const [orientacoes, setOrientacoes] = useState(null);
  const [values, setValues] = useState(defaultValues);
  const [carregando, setCarregando] = useState(false);
  const [nomeUsuario, setNomeUsuario] = useState('');
  const [arquivos, setArquivos] = useState([]);

  const [selectDesabilitadoCategoria, setSelectDesabilitadoCategoria] = useState(true);

  const alert = useAlert();
  const history = useHistory();
  const dispatch = useDispatch();
  const dadosCidade = useSelector(selectCidade);
  const dadosSecretaria = useSelector(selectSecretaria);
  const dadosLogin = useSelector(selectLogin);
  const { bairroTotem } = useSelector(selectBairroTotem);
  const { assuntoTotem } = useSelector(selectAssuntoTotem);
  const { categoriaTotem } = useSelector(selectCategoriaTotem);
  const { unidadeTotem } = useSelector(selectUnidadeTotem);

  const limpaLoginAnonimo = (data) => {
    if (data && data.data && data.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  const checaCidadeAtiva = (id) => {
    fetchVerificarStatusCidade(id).then((response) => {
      if (response === 'N') {
        dispatch(desfazerConexao());
        dispatch(desfazerCidade());
        dispatch(desfazerSecretaria());
        limpaLoginAnonimo(dadosLogin);
        history.push('/');
      }
    });
  };

  const validate = () => {
    if (!values.IdSecretariaAssunto) {
      alert.error('Verifique o campo assunto.', { timeout: 5000 });
      return false;
    }
    if (!values.IdCategoria) {
      alert.error('Verifique o campo categoria.', { timeout: 5000 });
      return false;
    }
    if (!values.Descricao) {
      alert.error('Verifique o campo manifestação.', { timeout: 5000 });
      return false;
    }
    if (!values.Endereco) {
      alert.error('Verifique o campo endereço da manifestação.', { timeout: 5000 });
      return false;
    }
    if (!values.IdBairro && values.Bairro !== '') {
      alert.error('Verifique o campo bairro.', { timeout: 5000 });
      return false;
    }
    if (!values.IdBairro) {
      alert.error('Verifique o campo bairro.', { timeout: 5000 });
      return false;
    }
    return true;
  };

  const [coordenadas, setCoordenadas] = useState({
    lat: Number(dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.Latitude),
    lng: Number(dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.Longitude),
  });

  const setVal = (key, val) => setValues({
    ...values, [key]: val,
  });

  useEffect(() => {
    // O CÓDIGO ABAIXO É RESPONSÁVEL POR SETAR NO MAPA COMO LOCALIZAÇÃO PADRÃO, A POSIÇÃO COM AS COORDENADAS DO USUÁRIO. Uma vez comentado, o mapa irá renderizar por padrão as coordenadas vindas do banco, definidas na criação do useState "coordenadas";
    // if (getTotem() !== 'true') {
    //   navigator.geolocation.getCurrentPosition((position) => {
    //     setCoordenadas({
    //       lat: position.coords.latitude,
    //       lng: position.coords.longitude,
    //     });
    //   });
    // }
    dispatch(desfazerBairro());
    dispatch(desfazerAssunto());
    dispatch(desfazerCategoria());
    dispatch(desfazerUnidade());
    fetchCarregarSolicitante().then((dados) => setNomeUsuario(dados.Solicitante));
  }, []);

  useEffect(() => {
    checaCidadeAtiva(dadosCidade && dadosCidade.data && dadosCidade.data.idCidade);
    Promise.all([
      fetchSecretarias3(),
      // fetchCategorias(),
      fetchBairros(),
    ]).then(([dadosSecretarias, dadosBairros]) => {
      setListaSecretarias(dadosSecretarias);
      setListaBairros(dadosBairros);
      setValues(defaultValues);

      // Verifica se há apenas um bairro. Caso sim, eu edito "bairroTotem", que automaticamente aciona um UseEffect que atualiza o ID e Campo.
      if (dadosBairros && dadosBairros.length === 1) {
        dispatch(selecionarBairro({ bairro: dadosBairros[0].Campo, bairroId: dadosBairros[0].Id }));
      }

      const secretaria = dadosSecretarias && dadosSecretarias.find(
        ({ Id }) => Id === dadosSecretaria.data.idSecretaria,
      );

      if (!secretaria) {
        history.push('/');
        dispatch(desfazerConexao());
        dispatch(desfazerSecretaria());
      }

      const assuntos = secretaria && secretaria.Assuntos;
      const unidades = secretaria && secretaria.Unidades;

      setListaAssuntos(assuntos);
      setListaUnidades(unidades);
    });
  }, [dadosSecretaria, dadosLogin]);

  // Region: useEffect's criados para controlar e atualizar o valor dos respectivos campos após a escolha da opção e fechamento do modal do respectivo campo.
  // Esses modais são outros componentes, logo precisamos trazer um valor o qual está dentro de um compomente (no caso o modal) o qual é invocado/chamado aqui.
  useEffect(() => {
    setValues({ ...values, IdBairro: bairroTotem && bairroTotem.bairroId, Bairro: bairroTotem });
  }, [bairroTotem]);

  useEffect(() => {
    // Aqui estou atribuindo o valor para assunto, e além disso, estou "limpando" o valor da categoria, pois esta precisa sempre ser limpada quando mudado o assunto.
    setValues({
      ...values, IdAssunto: assuntoTotem && assuntoTotem.assunto, IdSecretariaAssunto: assuntoTotem && assuntoTotem.assuntoId, IdCategoria: '',
    });

    // Toda lógica feita para quando o valor do assunto for selecionado/alterado, carregar dinamicamente as opções de categoria para o respectivo assunto selecionado.
    // Diferentemente do arquivo FormularioZeladoria.js, eu nao coloquei todo o código abaixo dentro de um método o qual é invocado no "onChange" do select. Eu precisei adicionar o código direto no useEffect por questões de passagem de valores entre componentes.
    setOrientacoes(null);
    dispatch(desfazerCategoria());
    if (assuntoTotem && assuntoTotem.assuntoId) {
      setSelectDesabilitadoCategoria(false);
      Promise.all([
        fetchOrientacoes(assuntoTotem.assuntoId),
        fetchCategoriasPermitidas(assuntoTotem.assuntoId),
      ]).then(([dadosOrientacoes, dadosCategorias]) => {
        setOrientacoes(dadosOrientacoes);
        if (!dadosCategorias.Error) {
          setListaCategorias(dadosCategorias);
        }
      });
    } else {
      setSelectDesabilitadoCategoria(true);
      setListaCategorias(null);
    }
  }, [assuntoTotem]);

  useEffect(() => {
    setValues({ ...values, IdCategoria: categoriaTotem && categoriaTotem.categoriaId });
  }, [categoriaTotem]);

  useEffect(() => {
    setValues({ ...values, IdUnidade: unidadeTotem && unidadeTotem.unidadeId });
  }, [unidadeTotem]);
  // End Region

  if (!listaSecretarias || !listaAssuntos /* || !listaCategorias */ || !listaBairros) {
    return (
      <Carregar />
    );
  }

  if (/* listaCategorias.Error || */ listaAssuntos.Error || listaBairros.Error) {
    history.push('/');
    dispatch(desfazerConexao());
    dispatch(desfazerCidade());
    dispatch(desfazerSecretaria());
    return (
      <Carregar />
    );
  }

  const formataNome = (nomes) => {
    const words = nomes.length > 0 && nomes.toLowerCase().split(' ');

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }
    return words && words.join(' ');
  };

  const retiraAcentos = (str) => {
    const comAcento = 'ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ';
    const semAcento = 'AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr';
    let novaStr = '';
    for (let i = 0; i < str.length; i += 1) {
      let troca = false;
      for (let a = 0; a < comAcento.length; a += 1) {
        if (str.substr(i, 1) === comAcento.substr(a, 1)) {
          novaStr += semAcento.substr(a, 1);
          troca = true;
          break;
        }
      }
      if (troca === false) {
        novaStr += str.substr(i, 1);
      }
    }
    return novaStr;
  };

  const checkAndroid = () => {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf('android') > -1;
    if (isAndroid) return true;
    return false;
  };

  const enviarZeladoria = async (event) => {
    event.preventDefault();
    checaCidadeAtiva(dadosCidade && dadosCidade.data && dadosCidade.data.idCidade);
    const nomeCidade = dadosCidade && dadosCidade.data && dadosCidade.data.nomeCidade;
    const dataAgora = new Date().toLocaleString();
    setCarregando(true);

    if (!validate()) {
      setCarregando(false);
      return;
    }

    const validarConfiguracoesAnonimas = await fetchConfiguracoes();

    if (validarConfiguracoesAnonimas && validarConfiguracoesAnonimas.OcultarAnonimoZeladoria === 'N' && dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'anonimo') {
      alert.error('As configurações da cidade foram alteradas e agora não é mais permitido enviar manifestações de forma anônima. Por favor, tente fazer o login.', { timeout: 10000 });
      setCarregando(false);
      return;
    }

    if (coordenadas.lat === Number(dadosCidade.configuracoes.Latitude) && getTotem() !== 'true') {
      setCoordenadas({
        lat: '',
        lng: '',
      });
      const data = async () => {
        const response = await fetchCoordsByAddress(`${values.Endereco} ${values.Numero} ${document.getElementById('selectBairro').options[document.getElementById('selectBairro').selectedIndex].text} ${dadosCidade.configuracoes.Cidade} ${dadosCidade.configuracoes.Estado}`);
        await setCoordenadas({
          lat: await response.lat,
          lng: await response.lng,
        });
        await setValues({
          ...values,
          Latitude: await response.lat,
          Longitude: await response.lng,
        });

        const resposta = await postZeladoria({
          ...values,
          Latitude: await response.lat,
          Longitude: await response.lng,
          anexos: arquivos,
          IdSecretaria: dadosSecretaria.data.idSecretaria,
        });

        if (resposta instanceof Array) {
          alert.error('Atenção, verifique a extensão dos arquivos permitidos.', { timeout: 4000 });
          setCarregando(false);
          return;
        }

        if (resposta.Error) {
          alert.error(resposta.Error, { timeout: 4000 });
          setCarregando(false);
          return;
        }

        setValues(defaultValues);
        setArquivos([]);

        setCarregando(false);

        alert.info(resposta.Message.replace('.', ''), { timeout: 20000 });

        if (checkAndroid()) {
          window.location.href = `rawbt:eOuve - ${nomeCidade}%0A%0A ${resposta.Message.replace('.', '')}%0A Data/hora: ${dataAgora}%0A Secretaria: ${retiraAcentos(dadosSecretaria.data.nomeSecretaria)}%0A Assunto: ${retiraAcentos(assuntoTotem && assuntoTotem.assunto)}%0A Categoria: ${retiraAcentos(categoriaTotem && categoriaTotem.categoria)}`;
        }

        const clientPrinters = null;
        const _this = this;// eslint-disable-line

        JSPM.JSPrintManager.auto_reconnect = true;// eslint-disable-line
        JSPM.JSPrintManager.start();// eslint-disable-line

        setTimeout(() => {
          function doPrinting() {
              const escpos = Neodynamic.JSESCPOSBuilder;// eslint-disable-line
            const doc = new escpos.Document();
            escpos.ESCPOSImage.load('data:image/png;base64,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')
              .then((logo) => {
                const escposCommands = doc
                  .font(escpos.FontFamily.B)
                  .align(escpos.TextAlignment.Center)
                  .size(1, 1)
                  .image(logo, escpos.BitmapDensity.D24)
                  .text((nomeCidade === 'ARISMIG') ? `${nomeCidade}` : `Prefeitura Municipal de ${nomeCidade}`)
                  .text(' ')
                  .font(escpos.FontFamily.A)
                  .size(1, 1)
                  .text(`${resposta.Message.replace('.', '')}`)
                  .text(' ')
                  .font(escpos.FontFamily.C)
                  .size(0, 0)
                  .text(`Data/hora: ${dataAgora}`)
                  .text(`Secretaria: ${retiraAcentos(dadosSecretaria.data.nomeSecretaria)}`)
                  .text(`Assunto: ${retiraAcentos(assuntoTotem && assuntoTotem.assunto)}`)
                  .text(`Categoria: ${retiraAcentos(categoriaTotem && categoriaTotem.categoria)}`)
                  .text(' ')
                  .text(' ')
                  .qrCode(`https://${retiraAcentos(nomeCidade).toLowerCase()}.eouve.com.br`, new escpos.BarcodeQROptions(escpos.QRLevel.L, 6))
                  .feed(1)
                  .cut()
                  .generateUInt8Array();
                  // create ClientPrintJob
                  const cpj = new JSPM.ClientPrintJob();// eslint-disable-line
                  const myPrinter = new JSPM.InstalledPrinter('PP-10(2)');// eslint-disable-line
                cpj.clientPrinter = myPrinter;
                // Set the ESC/POS commands
                cpj.binaryPrinterCommands = escposCommands;
                // Send print job to printer!
                cpj.sendToClient();
              });
          }
          doPrinting();
        }, 1000);

        setValues(defaultValues);

        dispatch(desfazerSecretaria());
      };
      await data();
      return;
    }

    const resposta = await postZeladoria({
      ...values,
      anexos: arquivos,
      IdSecretaria: dadosSecretaria.data.idSecretaria,
    });

    if (resposta instanceof Array) {
      alert.error('Atenção, verifique a extensão dos arquivos permitidos.', { timeout: 4000 });
      setCarregando(false);
      return;
    }

    if (resposta.Error) {
      alert.error(resposta.Error, { timeout: 4000 });
      setCarregando(false);
      return;
    }

    setValues(defaultValues);
    setArquivos([]);

    setCarregando(false);

    dispatch(abrirModalProtocoloZeladoria({
      nomeCidade,
      protocolo: resposta.Message,
      dataAgora,
      nomeSecretaria: retiraAcentos(dadosSecretaria && dadosSecretaria.data && dadosSecretaria.data.nomeSecretaria),
      assunto: retiraAcentos(assuntoTotem && assuntoTotem.assunto),
      categoria: retiraAcentos(categoriaTotem && categoriaTotem.categoria),
    }));

    if (checkAndroid()) {
      window.location.href = `rawbt:eOuve - ${nomeCidade}%0A%0A ${resposta.Message.replace('.', '')}%0A Data/hora: ${dataAgora}%0A Secretaria: ${retiraAcentos(dadosSecretaria.data.nomeSecretaria)}%0A Assunto: ${retiraAcentos(assuntoTotem && assuntoTotem.assunto)}%0A Categoria: ${retiraAcentos(categoriaTotem && categoriaTotem.categoria)}`;
    }

    const clientPrinters = null;
    const _this = this;// eslint-disable-line

    JSPM.JSPrintManager.auto_reconnect = true;// eslint-disable-line
    JSPM.JSPrintManager.start();// eslint-disable-line

    setTimeout(() => {
      function doPrinting() {
          const escpos = Neodynamic.JSESCPOSBuilder;// eslint-disable-line
        const doc = new escpos.Document();
        escpos.ESCPOSImage.load('data:image/png;base64,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')
          .then((logo) => {
            const escposCommands = doc
              .font(escpos.FontFamily.B)
              .align(escpos.TextAlignment.Center)
              .size(1, 1)
              .image(logo, escpos.BitmapDensity.D24)
              .text((nomeCidade === 'ARISMIG') ? `${nomeCidade}` : `Prefeitura Municipal de ${nomeCidade}`)
              .text(' ')
              .text('Zeladoria')
              .font(escpos.FontFamily.A)
              .size(1, 1)
              .text(`${resposta.Message.replace('.', '')}`)
              .text(' ')
              .font(escpos.FontFamily.C)
              .size(0, 0)
              .text(`Data/hora: ${dataAgora}`)
              .text(`Secretaria: ${retiraAcentos(dadosSecretaria.data.nomeSecretaria)}`)
              .text(`Assunto: ${retiraAcentos(assuntoTotem && assuntoTotem.assunto)}`)
              .text(`Categoria: ${retiraAcentos(categoriaTotem && categoriaTotem.categoria)}`)
              .text(' ')
              .text(' ')
              .qrCode(`https://${retiraAcentos(nomeCidade).toLowerCase()}.eouve.com.br`, new escpos.BarcodeQROptions(escpos.QRLevel.L, 6))
              .feed(1)
              .cut()
              .generateUInt8Array();
              // create ClientPrintJob
              const cpj = new JSPM.ClientPrintJob();// eslint-disable-line
              const myPrinter = new JSPM.InstalledPrinter('PP-10(2)');// eslint-disable-line
            cpj.clientPrinter = myPrinter;
            // Set the ESC/POS commands
            cpj.binaryPrinterCommands = escposCommands;
            // Send print job to printer!
            cpj.sendToClient();
          });
      }
      doPrinting();
    }, 1000);

    setValues(defaultValues);

    dispatch(desfazerSecretaria());
  };

  return (
    <>
      <Botao
        onClick={() => document.getElementById('formTotem').scrollBy({
          top: -850,
          left: 0,
          behavior: 'smooth',
        })}
        totemUp
      />
      <Botao
        onClick={() => document.getElementById('formTotem').scrollBy({
          top: 850,
          left: 0,
          behavior: 'smooth',
        })}
        totemDown
      />
      <Botao
        voltar
        label="Voltar"
        style={{
          marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
        }}
        onClick={() => {
          dispatch(desfazerSecretaria());
          dispatch(desfazerBairro());
          dispatch(desfazerAssunto());
          dispatch(desfazerCategoria());
          dispatch(desfazerUnidade());
        }}
      />
      <Botao
        sair
        label="Sair"
        style={{
          marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
        }}
        onClick={() => {
          dispatch(desfazerConexao());
          dispatch(desfazerSecretaria());
          dispatch(desfazerBairro());
          dispatch(desfazerAssunto());
          dispatch(desfazerCategoria());
          dispatch(desfazerUnidade());
          limpaLoginAnonimo(dadosLogin);
          history.push('/totem');
        }}
      />
      <AppBodyForm id="formTotem">
        <BreadCumbs>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              Você está em:
              {' '}
              <span style={{ fontWeight: 'bold' }}>Zeladoria</span>
              {' '}
              &rsaquo;
              {' '}
              <span style={{ fontWeight: 'bold' }}>Cadastrar uma nova reclamação</span>
              {' '}
              &rsaquo;
              {' '}
              <span style={{ fontWeight: 'bold' }}>Formulário</span>
            </div>
            <div>
              <span style={{ textAlign: 'right' }}>Logado como: </span>
              <span style={{ fontWeight: 'bold', textAlign: 'right' }}>{formataNome(nomeUsuario)}</span>
            </div>
          </div>
        </BreadCumbs>
        <Container style={{ marginTop: 180, paddingInline: 95 }} totem>
          <Interno>
            <Alerta style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <strong style={{ fontSize: '1.15em' }}>* Os campos com asterisco são obrigatórios.</strong>
            </Alerta>

            <Divisor style={{ marginBottom: 6, paddingBottom: 6 }} />

            <form id="teste">
              <FormControl
                type="secretariaTotem"
                dadosSecretaria={dadosSecretaria}
                onClick={() => dispatch(desfazerSecretaria())}
              />
              <LinhaForm>
                <FormControl
                  idCampo="selectAssunto"
                  value={assuntoTotem && assuntoTotem.assunto}
                  type="selectBairrosTotem"
                  label="Assunto:"
                  onChange={({ target }) => setVal('IdSecretariaAssunto', target.Id)}
                  required
                  placeholder="Selecione"
                  onClick={(e) => { dispatch(abrirModalAssunto({ assuntos: listaAssuntos })); e.target.blur(); }}
                />
                {(listaUnidades && listaUnidades.length > 0) && (
                  <FormControl
                    idCampo="selectUnidade"
                    value={unidadeTotem && unidadeTotem.unidade}
                    type="selectBairrosTotem"
                    label="Unidade:"
                    onChange={({ target }) => {
                      setVal('IdUnidade', target.id);
                    }}
                    placeholder="Selecione"
                    onClick={(e) => { dispatch(abrirModalUnidade({ unidades: listaUnidades })); e.target.blur(); }}
                  />
                )}
                <FormControl
                  idCampo="selectCategoria"
                  // value={categoriaTotem && categoriaTotem.categoria}
                  // A lógica do "values" está diferente para esse input pois eu preciso sempre limpa-lo caso o assunto seja alterado, pois as categorias mudam de acordo ao assunto selecionado.
                  value={categoriaTotem && categoriaTotem.categoria ? categoriaTotem.categoria : ''}
                  type="selectBairrosTotem"
                  label="Categoria:"
                  onChange={({ target }) => setVal('IdCategoria', target.id)}
                  required
                  placeholder="Selecione"
                  onClick={(e) => { dispatch(abrirModalCategoria({ categorias: listaCategorias })); e.target.blur(); }}
                  disabled={selectDesabilitadoCategoria}
                />
              </LinhaForm>
              {(dadosSecretaria.data.nomeSecretaria.toLowerCase() === 'coronavírus' || dadosSecretaria.data.nomeSecretaria.toLowerCase() === 'saúde' || dadosSecretaria.data.nomeSecretaria.toLowerCase() === 'covid-19') && (
                <>
                  <LinhaForm>
                    <FormControl
                      idCampo="inputCartaoSus"
                      value={sus(values.CartaoSus)}
                      label="Número do cartão SUS:"
                      onChange={({ target }) => setVal('CartaoSus', target.value)}
                      maxLength={19}
                      type="inputTotem"
                    />
                  </LinhaForm>
                </>
              )}

              {(orientacoes && orientacoes[0].Campo && orientacoes[0].Campo !== 'NULL') && (
                <>
                  <Orientacoes>
                    <b>Orientações ao Solicitante:</b>

                    <Divisor style={{ marginBottom: 2, paddingBottom: 2 }} />

                    <span>{orientacoes[0].Campo}</span>
                  </Orientacoes>

                  <Divisor size="ultraPequeno" />
                </>
              )}

              <FormControl
                idCampo="areaManifestacao"
                value={values.Descricao}
                label="Manifestação:"
                onChange={({ target }) => setVal('Descricao', target.value)}
                type="textareaTotem"
                maxLength={4000}
                required
              />

              {/* Ocultado o mapa na versão totem para todas as cidades */}
              {/* <div>
                {dadosCidade.configuracoes.ExibirMapaTotem === 'S' && (
                  <Mapa
                    coordenadas={coordenadas}
                    onClick={({ latLng }) => {
                      setCoordenadas({
                        lat: latLng.lat(),
                        lng: latLng.lng(),
                      });
                      fetchGeocodeByCoords(latLng.lat(), latLng.lng()).then((data) => {
                        setValues({
                          ...values,
                          Cep: (data && data.cep) ? data.cep : '',
                          Endereco: (data && data.endereco) ? data.endereco : '',
                          Numero: (data && data.numero) ? data.numero : '',
                          Latitude: latLng.lat(),
                          Longitude: latLng.lng(),
                        });
                      });
                    }}
                  />
                )}
              </div> */}

              <LinhaForm>
                <FormControl
                  idCampo="inputEndereco"
                  value={values.Endereco}
                  label="Endereço da manifestação:"
                  onChange={({ target }) => setVal('Endereco', target.value)}
                  required
                  direita
                  tamanhoFlex={7}
                  type="inputTotem"
                />

                <FormControl
                  idCampo="inputNumero"
                  value={number(values.Numero)}
                  label="Número:"
                  onChange={({ target }) => setVal('Numero', target.value)}
                  maxLength={5}
                  type="inputTotem"
                />
              </LinhaForm>

              <LinhaForm>
                <FormControl
                  idCampo="inputCep"
                  value={cep(values.Cep)}
                  label="CEP:"
                  onChange={({ target }) => setVal('Cep', target.value)}
                  direita
                  maxLength={9}
                  type="inputTotem"
                />

                <FormControl
                  idCampo="inputReferencia"
                  value={values.Referencia}
                  label="Referência:"
                  onChange={({ target }) => setVal('Referencia', target.value)}
                  direita
                  tamanhoFlex={2}
                  type="inputTotem"
                />
                <FormControl
                  idCampo="selectBairro"
                  value={(bairroTotem && bairroTotem.bairro && bairroTotem.bairro !== '' && bairroTotem.bairro) || values.IdBairro}
                  type="selectBairrosTotem"
                  label="Bairro:"
                  onChange={({ target }) => setVal('IdBairro', target.value)}
                  required
                  placeholder="Selecione"
                  onClick={(e) => { dispatch(abrirModalBairro({ bairros: listaBairros })); e.target.blur(); }}
                />
              </LinhaForm>

              <div style={{ marginTop: 20 }}>
                <FormControl
                  label="Solicitante possui deficiência?"
                  nameRadio="Urgente"
                  idRadio="radioSimUrgente"
                  valueRadio="S"
                  labelRadio="Sim"
                  changeRadio={({ target }) => setVal('Urgente', target.value)}
                  idRadio2="radioNaoUrgente"
                  valueRadio2="N"
                  labelRadio2="Não"
                  changeRadio2={({ target }) => setVal('Urgente', target.value)}
                  checkedRadio2
                  type="radioTotem"
                />
              </div>

              <FormFooterTotem>
                {carregando !== true
                  ? (
                    <>
                      <Botao
                        label="Enviar"
                        type="submit"
                        onClick={enviarZeladoria}
                        submitTotem
                      />
                    </>
                  )
                  : (
                    <Carregar />
                  )}
              </FormFooterTotem>

            </form>

          </Interno>
        </Container>
      </AppBodyForm>
    </>
  );
};

export default FormularioZeladoriaTotem;
